import React, { useEffect, useState } from "react";
import { GOSPEL_FRAGMENTS } from "../../config/gospelQuotes";

export default function TranslationOverlay({ active, targetLang }) {
  const [quote, setQuote] = useState("");

  useEffect(() => {
    if (!active) return;
    let i = 0;
    const interval = setInterval(() => {
      i = (i + 1) % GOSPEL_FRAGMENTS.length;
      setQuote(GOSPEL_FRAGMENTS[i]);
    }, 120);
    return () => clearInterval(interval);
  }, [active]);

  if (!active) return null;

  const langLabel = targetLang === "en" ? "English" : targetLang === "la" ? "Latina" : "Español";

  return (
    <div style={styles.overlay}>
      <div style={styles.glow} />
      <p style={styles.quote}>{quote}</p>
      <p style={styles.label}>Traduciendo a {langLabel}...</p>
    </div>
  );
}

const styles = {
  overlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(10,10,10,0.92)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    zIndex: 10,
    borderRadius: "16px",
    animation: "fadeIn 0.3s ease",
  },
  glow: {
    position: "absolute",
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(212,175,55,0.15) 0%, transparent 70%)",
    animation: "pulse 2s ease-in-out infinite",
  },
  quote: {
    color: "#D4AF37",
    fontSize: "1.4rem",
    fontFamily: "'Playfair Display', Georgia, serif",
    fontStyle: "italic",
    textAlign: "center",
    maxWidth: "80%",
    lineHeight: 1.4,
    textShadow: "0 0 20px rgba(212,175,55,0.3)",
    zIndex: 1,
  },
  label: {
    color: "#888",
    fontSize: "0.85rem",
    fontStyle: "italic",
    zIndex: 1,
  },
};
